// ═══════════════════════════════════════════════════════════════════════════
// ajustesConexionTn — lo que el vendedor carga a mano de su tienda (pantalla)
// ───────────────────────────────────────────────────────────────────────────
// ADR 2026-09-14 (tarifas TN). Espejo de PRESENTACIÓN del vocabulario que el
// adapter del canal declara en el servidor
// (`functions/syncAdapters/canonico/tienda-nube/ajustesConexion.js`): acá van
// etiqueta, ayuda y opciones; el servidor valida. La paridad de valores la
// fija `ajustesConexionTn.paridad.test.js` — si allá cambia el vocabulario y
// acá no, muere el test, no el vendedor con un select que rebota.
//
// El agregador neutro (`core/lib/ajustesConexionRegistro`) los junta por
// `plataforma`, igual que los dashboards (ADR 2026-08-16, decisión 1).
// ═══════════════════════════════════════════════════════════════════════════

export const AJUSTES_CONEXION_TN = Object.freeze([
  {
    clave: 'plazoAcreditacionPagoNube',
    plataforma: 'tienda-nube',
    etiqueta: 'Acreditación de Pago Nube',
    ayuda: 'El plazo que elegiste en Pago Nube para cobrar tus ventas: de él depende la comisión que se descuenta en Rentabilidad. Sin cargarlo, la comisión sale "no informada". Después de cambiarlo, "Recalcular todo (forzado)" en Rentabilidad.',
    vacio: 'Sin cargar',
    opciones: Object.freeze([
      { valor: 1, label: '1 día' },
      { valor: 7, label: '7 días' },
      { valor: 14, label: '14 días' },
    ]),
  },
])
